import { PayloadAction } from "@reduxjs/toolkit";
import { DataPointTemplate, FileDataProgress, UserInteractionStatus, WranglerItem } from "fileParsing/wrangler/types";

// Action types definition
export enum WranglerActionTypes {
  ADD_DATA = "@@wrangler/ADD_DATA",
  REMOVE_EXPORT = "@@wrangler/REMOVE_EXPORT",
  UPDATE_DATA = "@@wrangler/UPDATE_DATA",
  UPDATE_STATUS = "@@wrangler/UPDATE_STATUS",
}

// State definition
export type WranglerState = {
  readonly items: WranglerItem[];
  readonly counter: number;
};

// Actions definition
export type SetAddDataAction = PayloadAction<{ exportId: number; items: WranglerItem[] }, WranglerActionTypes.ADD_DATA>;
export type SetUpdateDataAction = PayloadAction<
  { id: number; template: DataPointTemplate; index?: number },
  WranglerActionTypes.UPDATE_DATA
>;
export type SetUpdateStatusAction = PayloadAction<
  {
    id: number;
    userStatus?: UserInteractionStatus;
    dataProgress?: Partial<FileDataProgress>;
    compiled: boolean;
  },
  WranglerActionTypes.UPDATE_STATUS
>;
export type SetRemoveExportAction = PayloadAction<{ id: number }, WranglerActionTypes.REMOVE_EXPORT>;

export type WranglerActions = SetAddDataAction | SetUpdateDataAction | SetUpdateStatusAction | SetRemoveExportAction;
